export const defaultForAddressEditModel = () => {
  return AddressEditModel.fromJS({
    line1: '',
    line2: '',
    suburb: '',
    postcode: '',
    countryCode: 'AU',
    state: 'NSW'
  })
}

export class AddressEditModel implements IAddressEditModel {
  /** Address 1 */
  line1?: string | undefined;
  /** Address 2 */
  line2?: string | undefined;
  /** City/Suburb */
  suburb?: string | undefined;
  /** Postcode/Zip */
  postcode?: string | undefined;
  /** State/County */
  state?: string | undefined;
  countryCode!: string;

  constructor(data?: IAddressEditModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.line1 = Data["line1"];
      this.line2 = Data["line2"];
      this.suburb = Data["suburb"];
      this.postcode = Data["postcode"];
      this.state = Data["state"];
      this.countryCode = Data["countryCode"];
    }
  }

  static fromJS(data: any): AddressEditModel {
    data = typeof data === 'object' ? data : {};
    let result = new AddressEditModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["line1"] = this.line1;
    data["line2"] = this.line2;
    data["suburb"] = this.suburb;
    data["postcode"] = this.postcode;
    data["state"] = this.state;
    data["countryCode"] = this.countryCode;
    return data;
  }
}

export interface IAddressEditModel {
  /** Address 1 */
  line1?: string | undefined;
  /** Address 2 */
  line2?: string | undefined;
  /** City/Suburb */
  suburb?: string | undefined;
  /** Postcode/Zip */
  postcode?: string | undefined;
  /** State/County */
  state?: string | undefined;
  countryCode: string;
}
